// import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLicense } from '@syncfusion/ej2-base';
import { AppModule } from 'src/app/app.module';
import { environment } from 'src/environments/environment';


// enableProdMode() is also called in app.module.ts; should only do once
// if (environment.production) {
//   enableProdMode();
// }

const env = environment;

registerLicense(env.syncfusionLicenseKey);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


